import { History, Link, Pencil } from "lucide-react";
import { TypeProduct } from "../const/products";
import { useAuth } from '../../../context/AuthContext';
import { dictionary } from '../../../utils/dictionary';
interface RenderEntryMethodSelectionProps {
  typeProduct: TypeProduct;
  handleLinkEntry: () => void;
  handleManualEntry: () => void;
  handlePreviousProductSelectType: () => void;
}

function RenderEntryMethodSelection({ typeProduct,
  handleLinkEntry,
  handleManualEntry,
  handlePreviousProductSelectType }:
  RenderEntryMethodSelectionProps) {
  const { language } = useAuth();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <button
        type="button"
        className={`flex flex-col items-center justify-center p-6 border-2 rounded-lg transition-all ${typeProduct === TypeProduct.LINK
          ? 'border-primary-600 bg-primary-50'
          : 'border-gray-200 hover:border-gray-300'
          }`}
        onClick={handleLinkEntry}
      >
        <Link className="w-8 h-8 mb-2 text-primary-600" />
        <h3 className="text-lg font-medium">{dictionary["import-from-link"][language]}</h3>
      </button>

      <button
        type="button"
        className={`flex flex-col items-center justify-center p-6 border-2 rounded-lg transition-all ${typeProduct === TypeProduct.MANUAL
          ? 'border-primary-600 bg-primary-50'
          : 'border-gray-200 hover:border-gray-300'
          }`}
        onClick={handleManualEntry}
      >
        <Pencil className="w-8 h-8 mb-2 text-primary-600" />
        <h3 className="text-lg font-medium">{dictionary["enter-manually"][language]}</h3>
      </button>

      <button
        type="button"
        className={`flex flex-col items-center justify-center p-6 border-2 rounded-lg transition-all ${typeProduct === TypeProduct.PREVIOUS
          ? 'border-primary-600 bg-primary-50'
          : 'border-gray-200 hover:border-gray-300'
          }`}
        onClick={handlePreviousProductSelectType}
      >
        <History className="w-8 h-8 mb-2 text-primary-600" />
        <h3 className="text-lg font-medium">{dictionary["your-products"][language]}</h3>
      </button>
    </div>
  );
}

export default RenderEntryMethodSelection;
